export const navbarAction = ()=>{
    return{
        type:"sidebar_click"
    }
}
